import {Text, View, StyleSheet} from "@react-pdf/renderer";
import moment from "moment";
import React from "react";

const Title = ({commitment, startingDate, endingDate, author}) => {
    return(
        <View style={styles.container}>
            <View style={styles.rowSpaceBetween}>
                <Text style={styles.h1}>{commitment.title_fi_FI}</Text>
                <View style={{display: "flex", alignItems: "flex-end"}}>
                    <Text style={styles.h3}>Raportti aikavälillä</Text>
                    <Text style={styles.h3}>{moment(startingDate).format("DD.MM.YYYY")} - {moment(endingDate).format("DD.MM.YYYY")}</Text>
                </View>
            </View>
            <Text style={styles.h3}>Laatinut {author}</Text>
        </View>
    )
}

export default Title

const styles = StyleSheet.create({
    h1: {
        fontSize: 20,
        fontWeight: "light",
        maxWidth: '70%'
    },
    h3: {
        fontSize: 12,
        fontWeight: "light",
    },
    rowSpaceBetween: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between"
    },
    container: {
        marginBottom: 40,
    }
})


// WEBPACK FOOTER //
// ./src/components/printable/Title.jsx